export default "__VITE_ASSET__Dw1EuzmX__"